import React, { useEffect, useState } from "react";
import Firebase from "../../../assets/Firebase";
import { useNavigate, useParams } from "react-router-dom";
import SurveyComponent from "./SurveyComponent";
import Cookies from 'universal-cookie';

const SurveyEngine = ({ props }) => {
  const { uid, surveyId } = useParams();
  const f = new Firebase();
  const navigate = useNavigate();

  const cookies = new Cookies();

  let reading = false;
  let readingLanguage = false;
  let [cookie, setCookie] = useState(false);

  const [config, setConfig] = useState({
    ...props,
    uid: uid,
    currentScreen: 0,
    surveyId: surveyId,
    survey: null,
    idResponse: "",
    IPAddress: null,
    MACAddress: null,
    logo: null,
    background: null,

    update: function (parameter, value) {
      setConfig((prevState) => ({
        ...prevState,
        [parameter]: value,
      }));
    }
  });

  useEffect(() => {
    setConfig((prevState) => ({
      ...prevState,
      ...props,
    }));
  }, [props]);

  useEffect(() => {
    if (config.logo == null && config.uid) {
      f.loadLogoUid(config.uid, (logoUrl) => {
        config.update("logo", logoUrl);
      }, (error) => {
        console.error("Error loading logo: ", error);
      });
    }
  }, [config.logo]);

  const loadBack = (survey) => {
    f.loadBackgroundUid(config.uid, survey?.path, (logoUrl) => {
      config.update("background", logoUrl);
    }, (error) => {
      console.error("Error loading logo: ", error);
    });
  }

  useEffect(() => {
    if(config.survey === null && !readingLanguage && !reading && config.lang === ""){
      readingLanguage = true;
      f.loadLanguageStart(uid, surveyId, (succes) => {
        config.setLang(succes)
      });
    }
    if(cookies.get(surveyId) !== undefined){
      setCookie(true);
    }
    if (uid && surveyId && config.survey === null && !reading && readingLanguage) {
      reading = true;
      f.loadCompleteSurvey(config, uid, surveyId, (survey) => {
        console.log("Survey loaded: ", survey);
        console.log("Config: ", config);
        config.update("survey", survey);
        loadBack(survey);
        f.loadAlternativeLanguages(config);
        f.loadLanguageDisplayMode(config);
        console.log(cookies.get(surveyId))
        if (cookies.get(surveyId) !== undefined) {
          f.createResponse(config, survey, (success) => { config.update("idResponse", success)})
        }
      }, (error) => {
        console.error("Error loading survey: ", error);
        reading = false;
      })
    }
  }, [uid, surveyId]);

  return (
    <SurveyComponent config={config} cookie={cookie}/>
  );
};

export default SurveyEngine;
